/**
 * External dependencies
 */
import { FC, PropsWithChildren } from 'react';

/**
 * Internal dependencies
 */
import { Layout } from 'antd';
import classes from './MainLayout.module.scss';

const MainLayout: FC<PropsWithChildren> = ({ children }) => (
	<Layout className={classes.layout}>{children}</Layout>
);

export default MainLayout;
